import { getToken } from "@/setup/api";

export default {
  user: {
    id: 1,
    name: "Fiel Digital",
    image_url: require("@/assets/images/placeholders/user/profile-pic.png"),
    email: "contato@editorafiel.com.br",
    birth_date: "26/08/1998",
    ddd: "12",
    phone: "39199999",
    is_active: true,
    course_list: [],
    unfinished_videos: [],
  },
  messages: [],
  logged: !!getToken(),
};
